import { render, staticRenderFns } from "./ProfileTalentDescription.vue?vue&type=template&id=3b3efe9a"
import script from "./ProfileTalentDescription.vue?vue&type=script&lang=js"
export * from "./ProfileTalentDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports